<!--<c-footer>-->
  <div>
    <span> &copy; {{ currentYear }} Dhabi</span>
  </div>
<!--</c-footer>-->
